export default __webpack_public_path__ + "static/media/MyJersey.ce1cc6a772f99abd0381d2d732be4614.webp";